// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/TimelineIcons.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-timeline-main {
  position: relative;
  left: 0;
  bottom: 0;
  overflow: hidden;
  border: solid 1px #888;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cesium-timeline-trackContainer {
  width: 100%;
  overflow: auto;
  border-top: solid 1px #888;
  position: relative;
  top: 0;
  left: 0;
}

.cesium-timeline-tracks {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.cesium-timeline-needle {
  position: absolute;
  left: 0;
  top: 1.7em;
  bottom: 0;
  width: 1px;
  background: #f00;
}

.cesium-timeline-bar {
  position: relative;
  left: 0;
  top: 0;
  overflow: hidden;
  cursor: pointer;
  width: 100%;
  height: 1.7em;
  background: linear-gradient(
    to bottom,
    rgba(116, 117, 119, 0.8) 0%,
    rgba(58, 68, 82, 0.8) 11%,
    rgba(46, 50, 56, 0.8) 46%,
    rgba(53, 53, 53, 0.8) 81%,
    rgba(53, 53, 53, 0.8) 100%
  );
}

.cesium-timeline-ruler {
  /* NOTE: The label and the ruler must use the same font/size */
  visibility: hidden;
  white-space: nowrap;
  font-size: 80%;
  z-index: -200;
}

.cesium-timeline-highlight {
  position: absolute;
  bottom: 0;
  left: 0;
  background: #08f;
}

.cesium-timeline-ticLabel {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  font-size: 80%;
  color: #eee;
}

.cesium-timeline-ticMain {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 50%;
  background: #eee;
}

.cesium-timeline-ticSub {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 33%;
  background: #aaa;
}

.cesium-timeline-ticTiny {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 25%;
  background: #888;
}

.cesium-timeline-icon16 {
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/Timeline/Timeline.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb;;;;;;;GAOC;AACH;;AAEA;EACE,8DAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yDAAoD;EACpD,4BAA4B;AAC9B","sourcesContent":[".cesium-timeline-main {\n  position: relative;\n  left: 0;\n  bottom: 0;\n  overflow: hidden;\n  border: solid 1px #888;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cesium-timeline-trackContainer {\n  width: 100%;\n  overflow: auto;\n  border-top: solid 1px #888;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n\n.cesium-timeline-tracks {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n.cesium-timeline-needle {\n  position: absolute;\n  left: 0;\n  top: 1.7em;\n  bottom: 0;\n  width: 1px;\n  background: #f00;\n}\n\n.cesium-timeline-bar {\n  position: relative;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  cursor: pointer;\n  width: 100%;\n  height: 1.7em;\n  background: linear-gradient(\n    to bottom,\n    rgba(116, 117, 119, 0.8) 0%,\n    rgba(58, 68, 82, 0.8) 11%,\n    rgba(46, 50, 56, 0.8) 46%,\n    rgba(53, 53, 53, 0.8) 81%,\n    rgba(53, 53, 53, 0.8) 100%\n  );\n}\n\n.cesium-timeline-ruler {\n  /* NOTE: The label and the ruler must use the same font/size */\n  visibility: hidden;\n  white-space: nowrap;\n  font-size: 80%;\n  z-index: -200;\n}\n\n.cesium-timeline-highlight {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background: #08f;\n}\n\n.cesium-timeline-ticLabel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  white-space: nowrap;\n  font-size: 80%;\n  color: #eee;\n}\n\n.cesium-timeline-ticMain {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 1px;\n  height: 50%;\n  background: #eee;\n}\n\n.cesium-timeline-ticSub {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 1px;\n  height: 33%;\n  background: #aaa;\n}\n\n.cesium-timeline-ticTiny {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 1px;\n  height: 25%;\n  background: #888;\n}\n\n.cesium-timeline-icon16 {\n  display: block;\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  background-image: url(\"../Images/TimelineIcons.png\");\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
